<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table bill mg-b-0 table-contact data-table">
        <thead>
          <tr>
            <th>{{ $t("express.快递渠道名称") }}</th>
            <th>{{ $t("express.运单号管理方式") }}</th>
            <th>{{ $t("express.启用状态") }}</th>
            <th class="tx-center">
              {{ $t("express.运单数量") }} (
              <span class="tx-white">{{ $t("express.未使用") }}</span> /
              <span class="tx-success">{{ $t("express.已使用") }}</span> /
              <span class="tx-gary">{{ $t("express.已作废") }}</span
              >)
            </th>
            <th>{{ $t("express.地址标签") }}</th>
            <th>{{ $t("express.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <span class="tx-white">{{ item.name }}</span>
            </td>
            <td class="valign-middle">
              <span v-if="item.expressCodeType == '1'" class="tx-white">
                {{ $t("express.快递公司预先提供") }}
              </span>
              <span v-if="item.expressCodeType == '2'" class="tx-white">
                {{ $t("express.月结/电子面单账号") }}
              </span>
              <span v-if="item.expressCodeType == '3'" class="tx-white">
                {{ $t("express.菜鸟电子面单") }}
              </span>
              <span v-if="item.expressCodeType == '4'" class="tx-white">
                {{ $t("express.顺丰快递管家") }}
              </span>
            </td>
            <td class="valign-middle">
              <span :class="item.status | statusColor">{{
                $t(expressStatus[item.status])
              }}</span>
            </td>
            <td class="valign-middle tx-center">
              <a
                v-if="item.expressCodeType == '1'"
                class="tx-white tx-underline"
                href="javascript:;"
                @click="viewTrackingList('unused', item)"
                >{{ item.yesCodeCnt }}</a
              >
              <span v-else>-</span>
              /
              <a
                class="tx-success tx-underline"
                href="javascript:;"
                @click="viewTrackingList('used', item)"
                >{{ item.noCodeCnt }}</a
              >
              /
              <a
                v-if="item.expressCodeType == '1'"
                class="tx-gray-600 tx-underline"
                href="javascript:;"
                @click="viewTrackingList('cancel', item)"
                >{{ item.cancelCodeCnt }}</a
              >
              <span v-else>-</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{
                item.expressCodeType == "1"
                  ? item.labelName
                  : $t("express.官方面单")
              }}</span>
            </td>
            <td class="valign-middle">
              <a
                v-if="
                  (item.status == '1' || item.status == '2') &&
                  isSysRights('SupplierExpressChannel.createUpdateChannel')
                "
                class="mg-r-10 tx-info"
                href="javascript:;"
                @click="modiExpress(item)"
                >{{ $t("express.修改") }}</a
              >
              <a
                v-if="
                  item.expressCodeType == '1' &&
                  isSysRights('SupplierExpressChannelCode.uploadChannelCode')
                "
                class="mg-r-10 tx-info"
                href="javascript:;"
                @click="uploadChannelCode(item.id)"
                >{{ $t("express.上传运单号") }}</a
              >
              <a
                v-if="isSysRights('SupplierExpressChannel.delChannel')"
                class="mg-r-10 tx-info"
                href="javascript:;"
                @click="delExpress(item.id)"
                >{{ $t("express.删除") }}</a
              >
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="6">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("express.没有符合条件的快递渠道") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
      expressStatus: arrDict.expressStatus,
    };
  },
  filters: {
    statusColor(val) {
      let color = "";
      switch (val) {
        case "1":
        case "4":
          color = "tx-success";
          break;
        case "3":
          color = "tx-warning";
          break;
        case "5":
          color = "tx-danger";
          break;
      }
      return color;
    },
  },
  methods: {
    modiExpress(item) {
      this.$emit("modiExpress", item);
    },
    delExpress(id) {
      this.$emit("delExpress", id);
    },
    uploadChannelCode(id) {
      this.$emit("uploadChannelCode", id);
    },
    viewTrackingList(type, item) {
      if (!this.isSysRights("SupplierExpressChannelCode.getCodeList")) return;
      this.$emit("viewTrackingList", type, item);
    },
  },
};
</script>

<style scoped>
a.tx-white:hover {
  color: #fff;
}
a.tx-success:hover {
  color: #23bf08;
}
a.tx-gray-600:hover {
  color: #868e96;
}
</style>

